import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson10: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson9"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Meditation</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson11"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[6.25rem] text-justify text-gainsboro-100 font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>
                <span>Importance of Meditation?</span>
              </b>
            </p>
            <p className="m-0">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Meditation has a rich and ancient history, spanning cultures
                  and religions across the globe. It originated thousands of
                  years ago and has been practiced in various forms by different
                  civilizations, including ancient Indian traditions, Taoist
                  practices in China, and Buddhist meditation techniques.
                  Throughout history, meditation has been recognized as a path
                  to inner peace, spiritual awakening, and self-discovery.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0 text-[1.88rem] text-white">
              <b>Spiritual Benefits of Meditation:</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Meditation is often intertwined with spirituality, offering
              profound benefits for the mind, body, and soul. By engaging in
              regular meditation, individuals can experience:
            </p>
          </div>
          <img
            className="relative w-[30.44rem] h-[41.31rem] object-cover"
            alt=""
            src="/21@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <p className="m-0 text-[1.88rem]">
            <b>Increased Self-Awareness:</b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Self-awareness is a powerful tool that can lead to significant
                personal growth and transformation. By cultivating
                self-awareness through meditation, individuals can develop a
                deeper understanding of themselves, their emotions, thoughts,
                and behaviours. This heightened self-awareness serves as a
                foundation for personal growth and facilitates transformative
                experiences. Here are a few examples of how self-awareness can
                lead to growth and transformation:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b>{`Emotional Regulation: `}</b>
                <span>
                  Through self-awareness, individuals become more attuned to
                  their emotions. They can identify and acknowledge their
                  feelings, whether positive or negative, without judgment. This
                  awareness enables them to respond to emotions in a healthy and
                  constructive manner, rather than reacting impulsively. By
                  understanding their emotional triggers and patterns,
                  individuals can make conscious choices to regulate their
                  emotions and cultivate emotional well-being.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Identifying Limiting Beliefs: `}</b>
                <span>
                  Self-awareness allows individuals to recognize their limiting
                  beliefs and thought patterns that may be holding them back.
                  They can observe the negative self-talk or self-doubt and
                  challenge these beliefs by replacing them with more empowering
                  and supportive thoughts. By shedding light on these limiting
                  beliefs, individuals can transform their mindset and embrace a
                  more positive and growth-oriented outlook on life.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Enhancing Relationships: `}</b>
                <span>{`Self-awareness plays a crucial role in relationships. By understanding their own emotions, triggers, and communication styles, individuals can navigate their interactions with others more effectively. They can identify patterns of `}</span>
                <span className="font-medium font-dm-sans">behaviour</span>
                <span>
                  {" "}
                  that may hinder their relationships and take steps to improve
                  their communication, empathy, and understanding. This
                  self-awareness fosters healthier and more fulfilling
                  connections with others.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Aligning with Values and Purpose: `}</b>
                <span>{`Self-awareness helps individuals explore their core values, passions, and purpose in life. By gaining clarity on what truly matters to them, individuals can make conscious choices aligned with their values. This alignment brings a sense of `}</span>
                <span className="font-medium font-dm-sans">fulfilment</span>
                <span>
                  {" "}
                  and meaning, guiding them towards a life that resonates with
                  their authentic self. It allows for intentional
                  decision-making and empowers individuals to pursue their
                  passions and purpose.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <b className="font-dm-sans">{`Personal Empowerment and Authenticity: `}</b>
                <span>
                  Self-awareness enables individuals to embrace their authentic
                  selves. By understanding their strengths, weaknesses, values,
                  and aspirations, individuals can confidently express
                  themselves and make choices aligned with their true identity.
                  This self-acceptance and authenticity empower individuals to
                  lead a more fulfilling and purpose-driven life, where they can
                  contribute their unique gifts to the world.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] font-medium">
          <p className="m-0">
            Through the journey of self-awareness, individuals embark on a path
            of personal growth and transformation. It opens the doors to
            self-discovery, empowers individuals to make conscious choices, and
            fosters a deeper connection with themselves and others. By
            cultivating self-awareness through practices like meditation,
            individuals can unlock their potential and embark on a
            transformative journey of personal growth and fulfilment.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            When we connect with the present moment through meditation, we
            cultivate a sense of mindfulness that can have profound effects on
            our well-being. By focusing our attention on the here and now, we
            can alleviate anxiety, worry, and regrets that often stem from
            ruminating over the past or fretting about the future. Let's explore
            a few examples of how this connection with the present moment can
            positively impact our lives:
          </p>
        </div>
        <img
          className="relative w-[30.44rem] h-[36.38rem] object-cover"
          alt=""
          src="/22@2x.png"
        />
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson11"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson10;
